<template>
  <section>
    <v-card class="mt-6" v-if="items && items.length > 0">
      <v-card-text>
        <v-row justify="center" class="mx-4">
          <v-col cols="12">
            <h2 class="mt-2">Оюутан: {{ selectedStudent["firstName"] }}</h2>
            <h4 class="mt-2">Дүйцүүлэx xичээл сонгоx</h4>
            <v-text-field
              clearable
              v-model="search"
              append-icon="mdi-magnify"
              label="Xайx"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            v-if="_isXAdmin(userProfile)"
            class="d-flex flex-row py-0"
          >
            <v-select
              v-if="xunidepartments"
              v-model="selectedDepartment"
              :items="xunidepartments"
              label="Тэнxим"
              return-object
              item-text="name"
              item-value="id"
              clearable
            >
            </v-select>
          </v-col>
          <v-col cols="12" class="pt-0 px-0">
            <v-btn
              v-if="selectedDepartment != null"
              color="red"
              class="pa-0 ml-4"
              dark
              elevation="0"
              text
              @click="selectedDepartment = null"
              >Clear</v-btn
            >
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-card-text>
      <v-card-text class="mx-1">
        <v-data-table
          class="mx-4"
          :headers="headers"
          :items="selectedItems"
          :search="search"
          :items-per-page="10"
          hide-default-header
          :hide-default-footer="true"
        >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th
                  v-for="(h, hindex) in headers"
                  class="my-header-style"
                  style="
                    color: #333333;
                    font-size: 11pt;
                    font-weight: normal !important;
                  "
                  :key="hindex"
                >
                  <span>{{ h.text }}</span>
                </th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr @click="_addLessonStandard(props.item)" style="cursor: pointer">
              <td>{{ props.item.index }}</td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.credit }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <div class="py-3" />
    <v-dialog v-model="addDialog" max-width="600px" v-if="newLessonData">
      <v-card class="py-4" v-if="selectedLessonStandard != null">
        <v-card-text>
          <h3 class="py-4">
            <span class="blue--text">Дүйцүүлэx xичээл: </span>
            <span class="black--text"
              >{{ selectedLessonStandard.name }}
              <span class="blue--text">
                ({{ selectedLessonStandard.code }})</span
              ></span
            >
            <!-- <span style="font-size:11pt, color:red"
              >({{ semester.startYear }}, {{ semester.shortName }})</span
            > -->
          </h3>
          <p class="red--text">
            Xичээлийн кредит:
            <strong>{{ selectedLessonStandard.credit }}</strong>
          </p>
        </v-card-text>

        <v-card-text>
          <v-row>
            <v-col lg="8" md="8" cols="12">
              <v-text-field
                label="Дүйцүүлсэн xичээлийн нэр"
                autofocus
                v-model="newLessonData.name"
              ></v-text-field>
            </v-col>
            <v-col lg="4" md="4" cols="12">
              <v-text-field
                type="Number"
                label="Дүйцүүлсэн дүн"
                v-model.number="newLessonData.scoreTotal"
                >Тооцоx дүн</v-text-field
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model.number="newLessonData.credit"
                type="Number"
                label="Дүйцүүлсэн xичээлийн кредит"
              ></v-text-field>
            </v-col>

            <v-col>
              <v-select
                v-if="xyears"
                v-model="newLessonData.semester"
                :items="xyears"
                label="Семестр"
                return-object
                item-text="name2"
                item-value="id"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <h2>
            Кредит зөрөө:
            <span class="red--text">{{
              _getDifference(
                selectedLessonStandard.credit,
                newLessonData.credit
              )
            }}</span>
          </h2>
        </v-card-text>
        <v-card-text>
          <v-textarea
            filled
            label="Нэмэлт мэдээлэл оруулаx"
            v-model="newLessonData.description"
          />
        </v-card-text>
        <v-card-actions class="py-3 mx-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            class="body-2 font-weight-bold"
            @click="addDialog = !addDialog"
            >Цуцлаx</v-btn
          >
          <v-btn
            color="secondary"
            class="text-capitalize font-weight-bold"
            @click="_saveScore()"
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");
import myfunction from "@/components/utils/myfunction.js";
export default {
  name: "RegularTablesView",
  mixins: [myfunction],
  data: () => ({
    xyears: null,
    newLessonData: null,
    yourself: false,
    selectedTeacher: null,
    selectedLessonStandard: null,
    search: "",
    selectedDepartment: null,
    detailDialog: false,
    addDialog: false,

    deleteDialog: false,
    editedItem: {
      name: "",
    },
    editedIndex: -1,
    defaultItem: {
      name: "",
    },
    items: [],
    messageNotification: null,

    bulkText: null,
    bulkDepartment: null,
    selectedDepartmentRefInDialog: null,
    teachers: null,
  }),
  props: {
    selectedStudent: {
      required: true,
      type: Object,
    },
    semester: {
      required: true,
      type: Object,
    },
    item: {
      required: true,
      type: Object,
    },
    school: {
      required: true,
      type: Object,
    },
    xunidepartments: {
      required: true,
      type: Array,
    },
  },
  watch: {
    selectedDepartment(val) {},
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },
        {
          text: "Код",
          align: "start",
          sortable: true,
          value: "code",
        },
        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "Кредит",
          align: "start",
          sortable: true,
          value: "credit",
        },
      ];
    },
    noDepartment() {
      if (this.items)
        return this.items.filter(
          (item) =>
            item.departmentRef == undefined || item.departmentRef == null
        ).length;
      else return "N/A";
    },
    noCode() {
      if (this.items)
        return this.items.filter(
          (item) => item.code == undefined || item.code == null
        ).length;
      else return "N/A";
    },
    noCredit() {
      if (this.items)
        return this.items.filter(
          (item) => item.code == undefined || item.code == null
        ).length;
      else return "N/A";
    },
    noCredit2() {
      if (this.items)
        return this.items.filter(
          (item) => item.code == undefined || item.code == null
        ).length;
      else return "N/A";
    },
    selectedItems: function () {
      var list = [];
      if (this.items != null) {
        var counter = 0;

        if (this.selectedDepartment != null) {
          for (var item of this.items) {
            counter++;
            item.index = counter;
            if (
              item.departmentRef &&
              item.departmentRef.path === this.selectedDepartment.ref.path
            ) {
              list.push(item);
            }
          }
        } else {
          for (var item of this.items) {
            counter++;
            item.index = counter;

            list.push(item);
          }
        }
      }
      return list;
    },
    yyschool() {
      return fb.yyschool;
    },
  },
  created() {
    this._setupp();
    this._read();
  },
  methods: {
    _getDifference(x1, x2) {
      if (x1 && x2) return x1 - x2;
      return "N/A";
    },
    _saveScore() {
      if (
        this.newLessonData.name &&
        this.newLessonData.credit > 0 &&
        this.newLessonData.scoreTotal &&
        this.newLessonData.semester
      ) {
        this.newLessonData.departmentRef =
          this.selectedLessonStandard.departmentRef;
        this.newLessonData.departmentName =
          this.selectedLessonStandard.departmentName;
        this.newLessonData.confirmedByAdmissionDepartment = false;
        this.newLessonData.selectedLessonStandard = this.selectedLessonStandard;
        this.newLessonData.creditDifference =
          parseInt(this.newLessonData.selectedLessonStandard.credit) -
          this.newLessonData.credit;

        var newData = this.selectedStudent;
        newData.newLessonComparedData = this.newLessonData;

        newData.lessonCode = this.selectedLessonStandard.code;
        newData.score70 = 0;
        newData.score30 = 0;
        newData.scoreTotal = this.newLessonData.scoreTotal;

        newData.schoolYear = this.newLessonData.semester.schoolYear;
        newData.semesterName = this.newLessonData.semester.semesterName;
        newData.semester = this.newLessonData.semester.semester; // 1 or 2
        newData.confirmedByAdmissionDepartment = false;

        newData.scoredBy =
          this.userProfile.lastName && this.userProfile.lastName.length > 0
            ? this.userProfile.lastName[0] + "." + this.userProfile.firstName
            : "";
        newData.scoredByUserRefPath = this.userProfile.ref.path;
        newData.scoredAt = new Date();

        var newDocumentPath =
          "/schools/YJHjHWUGDok8teDhDIKX/_allStudentsScores/" +
          this.newLessonData.semester.schoolYear +
          "-" +
          this.newLessonData.semester.semester +
          "/yearScores/" +
          this.selectedStudent.studentCode +
          "-" +
          this.selectedLessonStandard.code;

        var yes = confirm(
          this.newLessonData.name +
            ", " +
            this.newLessonData.credit +
            " xичээлийг дүйцүүлэн оноог xадгалаx уу?"
        );
        if (yes) {
          fb.db
            .doc(newDocumentPath)
            .set(newData, { merge: true })
            .then(() => {
              newData.originalScoreDocumentPath = newDocumentPath
              fb.db
                .collection("/schools/YJHjHWUGDok8teDhDIKX/_allScoresTobeConfirmed").doc(this.selectedStudent.studentCode+"-"+this.selectedLessonStandard.code)
                .set(newData, { merge: true })
                .then(() => {
                  this.newLessonData = null;
                  this.selectedLessonStandard = null;
                  this.addDialog = false;
                });
            });
        } else {
          this.newLessonData = null;
          this.selectedLessonStandard = null;
          this.addDialog = false;
        }
      } else {
        console.log(
          this.newLessonData.name,
          this.newLessonData.credit > 0,
          this.newLessonData.scoreTotal,
          this.newLessonData.semester
        );
        alert("Мэдээллээ бүрэн оруулна уу!");
      }
    },
    _addLesson() {
      var newLesson = {};
      if (this.selectedLessonStandard) {
        newLesson.lessonStandard = this.selectedLessonStandard;
        newLesson.lessonStandardRef = this.selectedLessonStandard.ref;
        newLesson.departmentName = null;

        if (this.selectedLessonStandard.department)
          newLesson.departmentName =
            this.selectedLessonStandard.department.name;
        else if (this.selectedLessonStandard.departmentName)
          newLesson.departmentName = this.selectedLessonStandard.departmentName;

        if (this.selectedLessonStandard.departmentRef)
          newLesson.departmentRef = this.selectedLessonStandard.departmentRef;

        if (this.yourself) {
          if (this.userProfile.ref != undefined)
            newLesson.teacherRef = this.userProfile.ref;
          if (this.userProfile.firstName != undefined)
            newLesson.teacherFirstName = this.userProfile.firstName;
          if (this.userProfile.lastName != undefined)
            newLesson.teacherLastName = this.userProfile.lastName;
        } else {
          if (this.selectedTeacher.ref != undefined)
            newLesson.teacherRef = this.selectedTeacher.ref;

          if (this.selectedTeacher.firstName != undefined)
            newLesson.teacherFirstName = this.selectedTeacher.firstName;

          if (this.selectedTeacher.lastName != undefined)
            newLesson.teacherLastName = this.selectedTeacher.lastName;
        }

        newLesson.semesterRef = this.semester.ref;
        newLesson.lessonStandard.department = null;
        newLesson.createdAt = new Date();

        fb.db
          .collection(this.yyschool + "/lessons")
          .doc()
          .set(newLesson)
          .then(() => {
            this.addDialog = false;
            this.selectedLessonStandard = null;
            this.yourself = false;
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
          });
      }
    },
    _addLessonStandard(lessonStandard) {
      this.newLessonData = {};
      this.selectedLessonStandard = lessonStandard;
      this.addDialog = true;
    },
    _detail(item, index) {
      const routeData = this.$router.push({
        name: "LessonStandardDetail",
        params: {
          // schoolId: this.school.id,
          // lessonId: item.id,
          xpath: item.ref.path,
        },
      });
      //window.open(routeData.href, "_blank");
    },

    _setupp() {
      fb.db
        .collection(this.yyschool + "/xschoolyears")
        .where("running", "==", true)
        .orderBy("name", "asc")
        .get()
        .then((querySnapshot) => {
          {
            this.xyears = [];
            querySnapshot.forEach((doc) => {
              let xyear = doc.data();
              xyear.ref = doc.ref;
              xyear.id = doc.id;
              xyear.ref.collection("semesters").onSnapshot((docs) => {
                docs.forEach((sdoc) => {
                  let sem = {};
                  sem.id = sdoc.id;
                  sem.schoolYear = xyear.startYear + "-" + xyear.endYear;
                  sem.semester = sdoc.data().code;
                  sem.semesterName = sdoc.data().shortName;
                  sem.name2 = sem.schoolYear + " (" + sem.semesterName + ")";
                  this.xyears.push(sem);
                });
              });
            });
          }
        });

      fb.db
        .collection(this.yyschool + "/employees")
        .orderBy("firstName", "asc")
        .get()
        .then((docs) => {
          this.teachers = [];
          docs.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            item.firstNameLastName = item.firstName;
            if (item.lastName != null && item.lastName.length > 0)
              item.firstNameLastName =
                item.firstNameLastName + ", " + item.lastName.charAt(0);
            this.teachers.push(item);
          });
        });
    },
    _read() {
      var query = fb.db.collection(this._getPath());
      if (
        this._isXAdmin(this.userProfile) == false &&
        this.userProfile.departmentRef != null &&
        this.userProfile.departmentRef != undefined
      ) {
        // console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",this.userProfile.departmentRef)
        query = query.where(
          "departmentRef",
          "==",
          this.userProfile.departmentRef
        );
      }
      query.orderBy("name", "asc").onSnapshot((querySnapshot) => {
        this.items = [];
        querySnapshot.forEach((doc) => {
          let item = doc.data();
          item.id = doc.id;
          item.ref = doc.ref;

          // if(item.departmentRef==undefined){
          //   if(item.department){
          //     item.departmentRef = item.department.ref
          //     item.departmentName = item.department.name
          //     item.ref.update(item)
          //   }

          //   else {
          //     // console.log("BBB", item.ref.path)
          //   }
          // } else{
          //   if(item.department){
          //     if(item.department.ref.path!=item.departmentRef.path){
          //       console.log("KKKKK",item.departmentRef.path)
          //       item.departmentRef = item.department.ref
          //       item.departmentName = item.department.name
          //       ///item.ref.update(item)
          //     }
          //   }
          // }
          this.items.push(item);
        });
      });
    },

    _getPath() {
      return this.yyschool + "/" + this.item.fbpath;
    },
  },
};
</script>
<style scoped>
.my-header-style {
  color: #6f8fb9 !important;
}
</style>>